import { FC, MouseEventHandler, ReactElement, useCallback } from 'react';
import cn from 'classnames';
import { FaCaretDown, FaInfoCircle } from 'react-icons/fa';

import Tooltip from '@components/Tooltip';

import './DashboardButton.scss';

export type DashboardButtonProps = {
  label?: string;
  style?: {
    [key: string]: any;
  };
  theme?: 'default' | 'transparent';
  iconAlignment?: 'start' | 'end';
  alignment?: 'left' | 'center';
  icon?: ReactElement;
  dropdown?: boolean;
  tooltip?: string;
  download?: string;
  opened?: boolean;
  active?: boolean;
  'data-id'?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
};

const DashboardButton: FC<DashboardButtonProps> = ({
  label,
  icon,
  iconAlignment = 'start',
  alignment = 'center',
  theme = 'default',
  style,
  dropdown,
  download,
  opened,
  'data-id': dataId,
  active,
  tooltip,
  onClick,
}) => {
  const handleCLick = useCallback(
    e => {
      if (!!download) {
        const file_path = download;
        const a = document.createElement('a');
        a.href = file_path;
        a.download = file_path.slice(file_path.lastIndexOf('/') + 1);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        return;
      }

      onClick && onClick(e);
    },
    [onClick, download],
  );
  return (
    <div
      className={cn('dashboard-button', {
        'dashboard-button_dropdown': dropdown,
        'dashboard-button_active': (dropdown && opened) || active,
        [`dashboard-button_${theme}`]: true,
        [`dashboard-button_align-${alignment}`]: true,
      })}
      style={style}
      data-id={dataId}
      onClick={handleCLick}
    >
      {iconAlignment === 'start' && icon}
      <span className="dashboard-button__content">{label}</span>
      {tooltip && (
        <Tooltip content={tooltip}>
          <FaInfoCircle />
        </Tooltip>
      )}
      {iconAlignment === 'end' && icon}
      {dropdown && (
        <div
          className={cn('dashboard-button__caret', {
            'dashboard-button__caret_opened': opened,
          })}
        >
          <FaCaretDown />
        </div>
      )}
    </div>
  );
};

export default DashboardButton;
